import { Tabs } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AvailabilityTab from './components/AvailabilityTab/AvailabilityTab';
import ItemsTab from './components/ItemsTab/ItemsTab';
import RentalsTab from './components/RentalsTab/RentalsTab';
import styles from './Inventory.module.css';

const Inventory: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Tabs
      className={styles.fillHeight}
      defaultActiveKey="items"
      items={[
        { key: 'items', label: t('inventory-tab-items'), children: <ItemsTab /> },
        { key: 'rentals', label: t('inventory-tab-rentals'), children: <RentalsTab /> },
        { key: 'availability', label: t('inventory-tab-availability'), children: <AvailabilityTab /> },
      ]}
    />
  );
};

export default Inventory;
